import React, { useState, useEffect } from 'react';
import LayoutDefault from 'Components/LayoutDefault/LayoutDefault';
import GetUserId from 'Components/UserLogged/UserId/UserId';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import UserCalendarFilter from './UserCalendarFilter/UserCalendarFilter';
import ListUserScheduleMonth from './ListUserScheduleMonth/ListUserScheduleMonth';
import SchedulePanel from './SchedulePanel/SchedulePanel';
import UserCalendarMonth from './UserCalendarMonth/UserCalendarMonth';

const UserCalendar = () => {
    useEffect(() => {
        document.title = "Redech | Planejamento mensal"
    }, [])

    const userIdLogged = GetUserId();
    const [sectorSelected, setSectorSelected] = useState(null);
    const [managerSelected, setManagerSelected] = useState(null);
    const [employeeSelected, setemployeeSelected] = useState(null);
    const [resetFilterDay, setResetFilterDay] = useState(null);

    const [selectedActualDate, setSelectedActualDate] = useState(new Date());
    const [sectors, setSectors] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const sectors = await ExecuteAxios.api('get', '/sector');
            setSectors(sectors);
        };

        fetchData();
    }, []);

    useEffect(() => {
        async function getSectorIdByLoggedEmployee() {
            if (userIdLogged) {
                const parameters = { userId: userIdLogged }
                const employeeData = await ExecuteAxios.api('get', `/employee/employee-by-userId/`, { params: parameters });
                if (employeeData && employeeData.length === 1) {
                    const sectorRow = employeeData[0].constructorList.find(item => item.field === 'sector');
                    const sector = sectorRow.argument;
                    if (sector) {
                        setSectorSelected(sector);
                    }
                }
            }
        };

        getSectorIdByLoggedEmployee();
    }, [userIdLogged])

    const informationUsersStylePanel = {
        flexDirection: 'row',
        display: 'flex',
        width: '100%',
        height: '50%'
    }

    const displayMain = {
        display: 'flex',
        flexDirection: 'row',
        width: '100%'
    }

    return (
        <>
            <LayoutDefault>
                <Panel style={displayMain}>
                    <UserCalendarFilter
                        onUpdateSectorSelected={val => { setSectorSelected(val) }}
                        onUpdateManagerSelected={val => { setManagerSelected(val) }}
                        onUpdateEmployeeSelected={val => { setemployeeSelected(val) }}
                        onUpdateSelectedActualDate={val => { setSelectedActualDate(val) }}
                        selectedActualDate={selectedActualDate}
                        sectorSelected={sectorSelected}
                        managerSelected={managerSelected}
                        employeeSelected={employeeSelected}
                        sectors={sectors}
                    />
                    <ListUserScheduleMonth
                        onUpdateResetFilterDay={val => { setResetFilterDay(val) }}
                        resetFilterDay={resetFilterDay}
                        sectorSelected={sectorSelected}
                        managerSelected={managerSelected}
                        employeeSelected={employeeSelected}
                        selectedActualDate={selectedActualDate}
                    />
                    <Panel
                        style={{
                            display: 'flex', flexDirection: 'column', '--modal-width-right': '40%'
                        }}
                        className={'main-modal three right'}>
                        <Panel style={informationUsersStylePanel}>
                            <SchedulePanel
                                onUpdateSectorSelected={val => { setSectorSelected(val) }}
                                onUpdateResetFilterDay={val => { setResetFilterDay(val) }}
                                sectorSelected={sectorSelected}
                                selectedActualDate={selectedActualDate}
                                sectors={sectors}
                            />
                        </Panel>
                        <UserCalendarMonth
                            sectorSelected={sectorSelected}
                            managerSelected={managerSelected}
                            onUpdateSelectedActualDate={val => { setSelectedActualDate(val) }}
                            resetFilterDay={resetFilterDay}
                            selectedActualDate={selectedActualDate}
                        />
                    </Panel>
                </Panel>
            </LayoutDefault >
        </>
    );
};

export default UserCalendar;
